/* tslint:disable */
/* eslint-disable */
/**
 * kus_server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * type of variant item selection method
 * @export
 * @interface ApiVariantItemSelectionMethod
 */
export interface ApiVariantItemSelectionMethod {
    /**
     *
     * @type {string}
     * @memberof ApiVariantItemSelectionMethod
     */
    key?: ApiVariantItemSelectionMethodKeyEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum ApiVariantItemSelectionMethodKeyEnum {
    Left = 'left',
    Right = 'right',
    Front = 'front',
    Rear = 'rear'
}



